import React, { useEffect, useState } from 'react';
import { Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Seo from 'sharedComponents/Seo';
import { appRoutes } from 'routes';
import { Link } from 'react-router-dom';
import Icon from 'sharedComponents/Icon';
import Alert from 'sharedComponents/Alert';
import { getServerError } from 'utils/errors';

import useApp from 'reducers/hooks/useApp';
import useFavoriteLoanOfficers from 'reducers/hooks/realEstateAgent/useFavoriteLoanOfficers';
import MyCustomLinkForm from './components/MyCustomLinkForm';
import FavoriteLoanOfficersList from './components/FavoriteLoanOfficersList';

import useStyles from './useStyles';

const RealEstateAgentDashboard = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { currentUser } = useApp();
  const {
    loadFavoriteLoanOfficers,
    favoriteLoanOfficers,
    isFavoriteLoanOfficersLoading,
    isFavoriteLoanOfficersIdle,
    updateFavoriteLoanOfficer,
    isFavoriteLoanOfficerUpdating,
  } = useFavoriteLoanOfficers();

  useEffect(() => {
    loadFavoriteLoanOfficers();
  }, []);

  const [alert, setAlert] = useState({ text: '', show: false, severity: 'success' });

  const handleActivateFavoriteLoanOfficer = async (id, active) => {
    try {
      await updateFavoriteLoanOfficer(id, { active });
      loadFavoriteLoanOfficers();
    } catch (error) {
      const message = getServerError(error);
      setAlert({ ...alert, text: message, show: true, severity: 'error' });
    }
  };

  const handleCloseAlert = () => setAlert({ ...alert, show: false });

  return (
    <div className={classes.container}>
      <Seo
        title={t('meta.RealEstateAgentDashboard.title')}
        description={t('meta.RealEstateAgentDashboard.description')}
      />
      <div className={classes.content}>
        <Typography variant="h1" className={classes.header}>
          {t('components.RealEstateAgentDashboard.header')}
        </Typography>

        <div className={classes.paper}>
          <div className={classes.form}>
            <MyCustomLinkForm currentUser={currentUser} />
            <Button
              startIcon={<Icon name="add" className={classes.addIcon} />}
              className={classes.button}
              to={appRoutes.loanOfficersPath()}
              component={Link}
              color="secondary"
            >
              {t('components.RealEstateAgentDashboard.addLoanOfficers')}
            </Button>
          </div>
          <div className={classes.loanOfficersList}>
            <FavoriteLoanOfficersList
              loanOfficers={favoriteLoanOfficers}
              isLoading={isFavoriteLoanOfficersLoading || isFavoriteLoanOfficersIdle}
              isUpdating={isFavoriteLoanOfficerUpdating}
              onActivate={handleActivateFavoriteLoanOfficer}
            />
          </div>
        </div>
      </div>
      {alert.show && <Alert text={alert.text} open severity={alert.severity} handleClose={handleCloseAlert} />}
    </div>
  );
};

export default RealEstateAgentDashboard;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentDashboard/RealEstateAgentDashboard.js